import axiosInstance from '../../../config/axiosInstance';
const handleSubmit = async (formData) => {
    try {        
        const CompanyID = localStorage.getItem("CompanyID");
        formData.ClientID = CompanyID;
        const UserID = localStorage.getItem("UserID");
        formData.UserID = UserID;
        const response = await axiosInstance.post(`/Job/AddJobNotification`, formData);     
    
    } catch (error) {
        console.error('Error posting data:', error);
    }

};

export { handleSubmit };